export default __webpack_public_path__ + "d87dca31079d27a74500e84bdfcd4464.svg";